export const extractMsg = (error, fallback = "An error occurred") => {
  const data = error.response?.data;

  if (data?.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).find(Boolean);
    if (first) return first;
  }

  return (
    data?.message || data?.exception || data?.error || error.message || fallback
  );
};

export const getLogo = (basePath, isDarkTheme) =>
  `${basePath}${isDarkTheme ? "-white" : ""}.png`;

export const showErrorToast = (
  messageApi,
  error,
  fallback = "An error occurred",
) => {
  const data = error.response?.data;
  const msg = extractMsg(error, fallback);
  console.error("Full API error:", error.response?.data || error.message);
  messageApi.error({
    content: msg.length > 300 ? msg.substring(0, 300) + "..." : msg,
    duration: 5,
  });
};
